import { useState, useEffect } from "react";
import { appFirestore } from "../firebase/config";

const useFirestore = (id) => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    const unsub = appFirestore
      .collection("academics")
      .where("type", "==", "profs")
      .where("subject", "==", id)
      .orderBy("date")
      .onSnapshot((snap) => {
        let documents = [];
        snap.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setDocs(documents);
      });

    return () => unsub();
    // this is a cleanup function that react will run when
    // a component using the hook unmounts
  }, [id]);

  return { docs };
};

export default useFirestore;
